module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag-container"
  }, _vm._l((_vm.tags), function(item) {
    return _c('dsTagItem', {
      attrs: {
        "item": item,
        "language": _vm.language
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1278e9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsTags.vue
// module id = 225
// module chunks = 2